import type { ImageStore, PromoWithFormat, Translations } from '@ps-int/promozavr/app/api/types';

export const PROMOZAVR_PROJECT = 'telemostDesktop';
export const PROMOZAVR_STAGE = 'page-init';
export const PROMOZAVR_MODEL = 'promozavr/select-promo';
export const FETCH_YOURSELF = 'fetch_yourself';
export const PROMOZAVR_TEST_APP = 'test_project';
export const PROMOZAVR_TEST_BUNKER_VERSION = 'test';

export type PromozavrRendererSource = 'local' | 'remote';
export type PromozavrStatus = 'idle' | 'loading' | 'success' | 'error';
export type PromozavrAllowedApp = typeof PROMOZAVR_TEST_APP;
export type PromozavrBunkerVersion = 'test' | 'prod';

export type SelectPromoSuppliersData = {
    bunkerConfigSupplierData: typeof FETCH_YOURSELF;
    billingDataSupplierData: typeof FETCH_YOURSELF;
    billingSubscriptionsDataSupplierData: typeof FETCH_YOURSELF;
    blackboxUserInfoSupplierData: typeof FETCH_YOURSELF;
    datasyncPromoDataSupplierData: typeof FETCH_YOURSELF;
    datasyncUserFeaturesSupplierData: typeof FETCH_YOURSELF;
    saasKvSegmentsSupplierData: typeof FETCH_YOURSELF;
};

export type PromozavrQueryParams = {
    app?: PromozavrAllowedApp;
    debug?: string;
    debugParams?: string;
};

export type SelectPromoModelInput = PromozavrQueryParams & {
    project: typeof PROMOZAVR_PROJECT;
    stage: typeof PROMOZAVR_STAGE;
    lang?: string;
    tld?: string;
    testIds: string[];
    skipPromos: string[];
    selectAllPromos: false;
    usePersistentQueues: false;
    suppliersData: SelectPromoSuppliersData;
};

export type SelectPromoModelInternalInput = SelectPromoModelInput & {
    bunkerVersion?: PromozavrBunkerVersion;
};

export type SelectPromoModelServerInput = SelectPromoModelInternalInput & {
    fastFail?: boolean;
};

export type SelectPromoModelResponse = {
    selectedPromos?: PromoWithFormat[];
    translations?: Translations;
    images?: ImageStore;
    isSelected: boolean;
};

export type PromozavrState = {
    status: PromozavrStatus;
    request?: SelectPromoModelServerInput;
    requestKey?: string;
    selectedPromo?: PromoWithFormat;
    translations?: Translations;
    images?: ImageStore;
    isSelected: boolean;
    rendererSource: PromozavrRendererSource;
    lastError?: string;
};
